import { Typography } from 'antd'

export interface IBadgeProps {
  title: string
  variant: TVariant
}

export type TVariant = 'info' | 'error' | 'success' | 'warning'

const Badge = (props: IBadgeProps) => {
  const { title, variant } = props

  const labelColors = {
    success: {
      bgColor: 'bg-[#F1F8E9]',
      fontColor: 'text-[#72BA24]',
    },
    info: {
      bgColor: 'bg-[#CFE2FF]',
      fontColor: 'text-[#0A58CA]',
    },
    error: {
      bgColor: 'bg-[#FEE9E8]',
      fontColor: 'text-[#F82416]',
    },
    warning: {
      bgColor: 'bg-[#FFF6E6]',
      fontColor: 'text-[#FCA501]',
    },
  }

  const backgroundColor = labelColors[variant]?.bgColor
  const fontColor = labelColors[variant]?.fontColor

  return (
    <div className={`${backgroundColor} rounded-3xl`} data-testid="badge-wrapper">
      <Typography className={`${fontColor} font-bold text-sm py-2 px-4 w-full text-center`}>
        {title}
      </Typography>
    </div>
  )
}

export default Badge
